import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['bar', 'slider', 'video']

  static values = {
    duration: Number
  }

  connect() {
    if (!this.hasBarTarget) return

    // console.log('progress controller start')

    this.duration = 0;
    this.elapsed = 0;

    if (this.sliderTarget) {
      const swiper = this.sliderTarget.swiper;

      // console.log(swiper.params)
      // console.log(swiper.autoplay)

      this.updateFromSwiper(swiper);
      swiper.on('slideChange', () => {
        this.updateFromSwiper(swiper);
      })

      this.tick = setInterval(() => {
        // if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;

        if (this.elapsed > this.duration) {
          this.setProgress(0);
        } else if (this.duration > 0) {
          var percentage = (100 / this.duration) * this.elapsed;
          this.setProgress(percentage)
          this.elapsed += 10;
        }
      }, 10);

      // setInterval(() => {
      //     console.log(
      //       'Autoplay running/paused/duration ',
      //       swiper.autoplay.running,
      //       '/',
      //       swiper.autoplay.paused,
      //       '/'
      //     )
      // }, 1000);
    }
  }

  updateFromSwiper(swiper) {
    // console.log('updateFromSwiper');
    // console.log(swiper.params)

    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    let delay = swiper.params.autoplay.delay;
    let speed = parseInt(swiper.params.speed || 0);

    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }

    if ($activeSlideEl[0].classList.contains('is-video')) {
      var video = $activeSlideEl[0].getElementsByTagName('video')[0];
      video.currentTime = 0;
    }

    this.elapsed = 0;
    this.duration = parseInt(delay);

    if (swiper.params.autoplay.waitForTransition && speed > 0) {
      this.duration -= speed;
    }

    // console.log('duration: ' + this.duration)
  }

  setProgress(percentage) {
    if (percentage > 100) {
      percentage = 100;
    }

    if (percentage > 0) {
      var value = (251.2 / 100) * percentage;
    } else {
      var value = 0;
    }

    this.barTarget.setAttribute('stroke-dasharray', value+',251.2');
  }
}